import React from 'react';

import Button from '@atlaskit/button';
import { Text } from '@atlaskit/primitives';
import { openEditRuleDialog } from 'src/services/rules';

const V3RuleMessage = () => {
  return (
    <Text size="small" color="color.text.accent.orange"> (legacy)</Text>

  );
};

const Name = ({ name, id, isV3Rule }) => {
  return <div><Button onClick={e => openEditRuleDialog(id)} appearance="link">{name}</Button>{isV3Rule && <V3RuleMessage/>}</div>;
};

export default Name;
